import { Dialog } from "primereact/dialog";
import DialogFooter from "./DialogFooter";

const FormDialog = ({
  children,
  visible,
  closeDialog = null,
  acceptDialog = null,
  acceptText = "Aceptar",
  isAcceptDisabled = false,
  footer = null,
  header = null,
  title = "",
  width = "600px",
  ...props
}) => {
  const dialogHeader = header ? header : header === null ? title : <></>;
  const dialogFooter = footer
    ? footer
    : footer === null
    ? (
        <DialogFooter
          accept={acceptText}
          handleCancel={closeDialog}
          handleAccept={acceptDialog}
          isAcceptDisabled={isAcceptDisabled}
        />
      )
    : null;

  // Creamos un objeto de props condicional
  const dialogProps = {
    visible,
    style: { width },
    header: dialogHeader,
    modal: true,
    className: "p-fluid",
    onHide: closeDialog,
    ...props,
  };

  // Solo agregamos footer si existe
  if (dialogFooter) dialogProps.footer = dialogFooter;

  return <Dialog {...dialogProps}>{children}</Dialog>;
};

export default FormDialog;

